import * as React from 'react';
import ErrorSelectIndicator from '../ErrorSelectIndicator';

/**
 * Crée les composants personnalisés pour l'état d'erreur
 */
export const createErrorComponents = (errorMessage: string) => ({
    DropdownIndicator: () => <ErrorSelectIndicator message={errorMessage} />,
});
